import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import siteConfig from "../config/siteConfig";
import "../css/paysuccess.css";

const PaySuccess = () => {
  const location = useLocation();
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const orderTotal = Number(location.state?.orderTotal);
  const hasCompletedOrder = Number.isFinite(orderTotal) && orderTotal > 0;
  const formattedTotal = new Intl.NumberFormat(
    siteConfig.currency?.locale || "en-US",
    {
      style: "currency",
      currency: siteConfig.currency?.code || "USD",
    }
  ).format(orderTotal || 0);

  if (!hasCompletedOrder) {
    return (
      <main className="payment-success">
        <section
          className="payment-success__panel"
          aria-labelledby="payment-status-title"
        >
          <p className="payment-success__kicker">ORDER STATUS</p>
          <h1 id="payment-status-title">No recent order.</h1>
          <p className="payment-success__lead">
            Complete the demo checkout before viewing an order confirmation.
          </p>
          <div className="payment-success__actions">
            <Link to="/shop" onClick={scrollToTop}>Shop the collection</Link>
            <Link to="/cartpage" onClick={scrollToTop}>View cart</Link>
          </div>
        </section>
      </main>
    );
  }

  return (
    <main className="payment-success">
      <section className="payment-success__panel" aria-labelledby="payment-success-title">
        <div className="payment-success__mark" aria-hidden="true">
          <FontAwesomeIcon icon={faCheck} />
        </div>
        <p className="payment-success__kicker">DEMO COMPLETE / NO PAYMENT TAKEN</p>
        <h1 id="payment-success-title">Thank you.</h1>
        <p className="payment-success__lead" role="status" aria-live="polite">
          Your {siteConfig.brandName} checkout demonstration is complete.
          No payment was taken and no order was sent for fulfilment.
        </p>
        <p className="payment-success__total">
          Demo order total <strong>{formattedTotal}</strong>
        </p>
        <div className="payment-success__rule" aria-hidden="true" />
        <p className="payment-success__note">
          Contact us if you would like to ask about purchasing availability.
          This demonstration does not send order or tracking emails.
        </p>
        <div className="payment-success__actions">
          <Link to="/shop" onClick={scrollToTop}>Continue shopping</Link>
          <Link to="/contact" onClick={scrollToTop}>Contact customer service</Link>
        </div>
      </section>
    </main>
  );
};

export default PaySuccess;
